import { Grid } from "@mui/material";
import React from "react";
import ContactPersonHeader from "./home/header";
import ContactPersonTable from "./home/table";

const ContactPerson = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ContactPersonHeader />
      </Grid>
      <Grid item xs={12}>
        <ContactPersonTable />
      </Grid>
    </Grid>
  );
};

export default ContactPerson;
